import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const GEOIP_LOCATION_SCHEMA = Object.freeze({
  ACCURACY_RADIUS: Number.MAX_VALUE,
  LATITUDE: null,
  LONGITUDE: null,
  TIME_ZONE: '',
});
const RECORD = generateSchema(GEOIP_LOCATION_SCHEMA);
const KEYS: any = generateKeys(GEOIP_LOCATION_SCHEMA);

export class GeoipLocation extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accuracyRadius(): number {
    return this.get(KEYS.ACCURACY_RADIUS);
  }

  get latitude(): number {
    return this.get(KEYS.LATITUDE);
  }

  get longitude(): number {
    return this.get(KEYS.LONGITUDE);
  }
}
